import { SHOW_CONFIRM_MODAL, HIDE_CONFIRM_MODAL } from './types';

export const showConfirmModal = (params) => ({
  type: SHOW_CONFIRM_MODAL,
  ...params,
});
export const hideConfirmModal = () => ({ type: HIDE_CONFIRM_MODAL });
